<template>
  <div>
    <CrudList 
      title="Nuevos Spot" 
      storeName="Notifications_cms" 
      :canAdd="false" 
      :canEdit="false" 
      :canDelete="false"
      sortable 
      :filters="filters" 
      :canExport="true" 
      canSearch
      next-link="/admin/deleted_spots"
      :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/notifications_cms'
      },
      {
        text: 'Nuevos Spots',
        disabled: false,
        href: '#'
      },
    ]"
    >
      <template v-slot:head-list="{ }">
        <v-row class="mb-3">
          <v-col cols="4">
            <v-select 
              label="Estado" 
              :items="status" 
              item-text="name" 
              item-value="value" 
              v-model="data.deleted"
              class="select-search max-w-270"
              solo
              elevation="0"
              dense
              hide-details
              append-icon="$caretDownIcon"
              clearable>
            </v-select>
          </v-col>
          <v-col cols="4">
            <v-select 
              label="Verificacion" 
              :items="verification" 
              item-text="name" 
              item-value="value"
              v-model="data.verified" 
              clearable
              class="select-search max-w-270"
              solo
              elevation="0"
              dense
              hide-details
              append-icon="$caretDownIcon"
              >
            </v-select>
          </v-col>
          <v-col cols="4">
            <v-select
                label="Tipo de Spot"
                :items="spotTypes"
                item-text="name"
                item-value="value"
                v-model="data.spot_type"
                clearable
                class="select-search max-w-270"
                solo
                elevation="0"
                dense
                hide-details
                append-icon="$caretDownIcon"
            >
            </v-select>
          </v-col>
        </v-row>
      </template>

      <template v-slot:createdAt="{ item }">
        {{ parseDate(item.createdAt) }}
      </template>
      <template v-slot:email_user="{ item }">
        {{ item.user_id ? item.user_id.email : "" }}
      </template>
      <template v-slot:completed_name="{ item }">
        {{ item.user_id.name || '' }} {{ item.user_id.last_name || '' }}
      </template>
      <template v-slot:alias_id="{ item }">
        {{ item.alias_id ? item.alias_id : "" }}
        {{ item.address ? item.address : "" }}
        {{ item.unit ? item.unit : "" }}
      </template>
      <template v-slot:home_constancy="{ item }">
        {{ item.home_constancy ? 'SI' : "NO" }}
      </template>
      <template v-slot:has_sticker="{ item }">
        {{ item.has_sticker ? 'SI' : "NO" }}
      </template>
      <template v-slot:verified="{ item }">
        {{ item.verified ? item.verified : false }}
      </template>
      <template v-slot:deleted="{ item }">
        {{ item.deleted ? "SI" : "NO" }}
      </template>
      <template v-slot:details="{ item }">
        <v-btn elevation="0" class="my-1 custom-btn-round-gray btn-round-md" 
          @click="$router.push('/admin/notifications_cms/edit/' + item.id)">
          <img :src="icon_detail" alt="" width="25px" />
        </v-btn>
      </template>
      <template v-slot:availabledays="{ item }">
        <v-btn elevation="0" class="my-1 custom-btn-round-gray btn-round-md"  @click="
          $router.push(
            '/admin/notifications_cms/' +
            item.id +
            '/available_days'
          )
          ">
          <img :src="icon_time" alt="" width="25px" />
        </v-btn>
      </template>
      <template v-slot:spot_id="{ item }">
        <v-btn elevation="0" class="my-1 btn-black btn-round-md" rounded color="primary"
          @click="$router.push('/admin/notifications_cms/' + item.id + '/reviews')">
          Reviews
        </v-btn>
      </template>
      <template v-slot:spots="{ item }">
    </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: { CrudList },
  watch: {
    "data.deleted": {
      handler(val) {
        this.filters.deleted = val;
      },
    },
    "data.verified": {
      handler(val) {
        this.filters.verified = val;
      },
    },
    "data.spot_type": {
      handler(val) {
        this.filters.spot_type = val;
      }
    },
    options: {
      handler(val) {
        const values = Object.keys(this.data);
        const keys_options = Object.keys({ ...val });
        for (const key of values) {
          if (keys_options.includes(key.toString()) && val[key] !== null) {
            this.data[key] = val[key];
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      options: (state) => state.Notifications_cms.options,
      icon_detail: (state) => state.Menu.icon_detail,
      icon_time: (state) => state.Menu.icon_time,
    }),
  },
  data: () => ({
    offsetTop: 0,
    filters: {
      deleted: false,
      verified: null,
      spot_type: null,
    },
    status: [
      { name: "Todos", value: null },
      { name: "Eliminado", value: true },
      { name: "No eliminado", value: false },
    ],
    verification: [
      { name: "Verificado", value: true },
      { name: "No verificado", value: false },
    ],
    spotTypes: [
      // { name: "Todos (tipos de spot)", value: null },
      { name: "Casas", value: "casas" },
      { name: "Parking", value: "parking" },
      { name: "Otros", value: "otros" },
    ],
    data: {
      deleted: null,
      verified: null,
      spot_type: null,
    },
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    parseDate: (date, format = "DD/MM/YYYY HH:mm:ss") =>
      moment(date, "MM-DD-YYYY HH:mm:ss", true).format(format),
  },
};
</script>
